import React from 'react';
import { components } from 'react-select';

export const CustomInput = (props) => {
  const customProps = {
    ...props,
    isHidden: false,
  };
  return <components.Input {...customProps} />;
};
